import { Model } from 'modules/core/lib/mobx-rest'

interface ICurrency {
  iso_code: string
  name: string
  symbol: string
  priority: number
}

class Currency extends Model<ICurrency> {
  static urlRoot() {
    return '/currencies'
  }

  get primaryKey(): string {
    return 'iso_code'
  }
}

export default Currency
